import { omit } from 'lodash';
import { useMutation } from '@tanstack/react-query';
import useApiExceptionHandler from 'hooks/ui/useApiExceptionHandler';
import { useNotification } from 'hooks/ui/useNotification';
import { api } from 'lib/httpClient';
import { Api } from 'further-types/investor';
import { ApiResponse } from 'further-types/api';
import trpcApi from 'lib/trpcClient';

export function useInvestorDisability() {
  const apiUtils = trpcApi.useUtils();
  const handleApiException = useApiExceptionHandler();
  const notification = useNotification();

  return useMutation({
    throwOnError: false,
    mutationFn: async (
      data: Api.UpdateInvestorDisabilityRequest & { investorId: string },
    ) => {
      const body = omit(data, 'investorId');
      await api.put<ApiResponse<null>>(
        `investor/${data.investorId}/update-disability`,
        body,
      );
      return data;
    },
    onSuccess: async ({ investorId, isDisabled, disableAllEmails }) => {
      let message = '';
      if (isDisabled !== undefined) {
        message = isDisabled ? 'Investor disabled.' : 'Investor enabled.';
      }
      if (disableAllEmails !== undefined) {
        message = disableAllEmails
          ? 'Emails have been disabled for this investor.'
          : 'Emails have been enabled for this investor.';
      }
      notification.success(message);

      await apiUtils.investor.getInvestor.invalidate({ investorId });
      await apiUtils.investor.listInvestors.invalidate();
    },
    onError: (error: Error) => {
      handleApiException(error);
    },
  });
}
